import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./BreakingBoundaries.css";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const BreakingBoundaries = () => {
  const { currentLang } = useContext(LanguageContext);
  const [section, setSection] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/BreakingBoundariesSection?lang=${currentLang}`
        );

        const data = res.data;
        setSection(data);

        // Default active tab (video)
        if (data?.media?.video) {
          setActiveTab({
            id: 1,
            label: data.tabs.fordingDepth,
            type: "video",
            src: resolveUrl(data.media.video),
          });
        }
      } catch (err) {
        console.error("Error fetching Breaking Boundaries section:", err);
      }
    };

    fetchData();
  }, [currentLang]);

  if (!section) return null;

  // Build tabs array safely
  const tabs = [
    {
      id: 1,
      label: section.tabs.fordingDepth,
      type: "video",
      src: resolveUrl(section.media.video),
    },
    {
      id: 2,
      label: section.tabs.tiltAngle,
      type: "image",
      src: resolveUrl(section.media.images.image1),
    },
    {
      id: 3,
      label: section.tabs.climbingAngle,
      type: "image",
      src: resolveUrl(section.media.images.image2),
    },
    {
      id: 4,
      label: section.tabs.passageAngle,
      type: "image",
      src: resolveUrl(section.media.images.image3),
    },
    {
      id: 5,
      label: section.tabs.approachAngle,
      type: "image",
      src: resolveUrl(section.media.images.image4),
    },
    {
      id: 6,
      label: section.tabs.groundClearance,
      type: "image",
      src: resolveUrl(section.media.images.image5),
    },
  ];

  return (
    <section className="breaking-boundaries">
      {/* Header */}
      <div className="boundaries-header">
        <h1>{section.title}</h1>
        <p>{section.description}</p>
      </div>

      {/* Tabs */}
      <div className="boundaries-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-btn ${activeTab?.id === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Media Display */}
      <div className="boundaries-media">
        {activeTab?.type === "video" ? (
          <video
            src={activeTab.src}
            autoPlay
            loop
            muted
            playsInline
            className="boundaries-video"
          />
        ) : (
          <img
            src={activeTab.src}
            alt={activeTab.label}
            className="boundaries-image"
          />
        )}
      </div>

      {/* Bottom Section */}
      <div className="bb-down">
        <h1>{section.bottomSection.title}</h1>
        <p>{section.bottomSection.description}</p>
      </div>
    </section>
  );
};

export default BreakingBoundaries;
